module.exports = __webpack_public_path__ + "img/image2.fa43ba29.jpg";